import { Injectable, OnDestroy } from '@angular/core';
import { ImageBlob } from '../../classes/image-blob';

export type imageSize = 'full' | 'midsize' | 'thumbnail' | 'banner';

@Injectable({
    providedIn: 'root',
})
export class ImageBlobCacheService implements OnDestroy {
    // #region Properties

    protected cache: Record<string, ImageBlob | null> = {};

    // #endregion

    // TODO: Automatic cache dump when size of cached images grows too large (50mb?)

    ngOnDestroy(): void {
        // On destroy, tear down the cache.
        const keys = Object.keys(this.cache);

        keys.forEach((k) => {
            const id = +k.substring(8);
            this.remove(id);
        });
    }

    // #region Add

    add(id: number, size: imageSize, item: ImageBlob) {
        if (id == null) throw new Error('No key provided to image blob cache.');
        if (!size) throw new Error('No image size provided to image blob cache.');
        if (!item) throw new Error('No image provided to image blob cache.');

        this.remove(id, size);

        const key = `ibcache-${id}-${size}`;
        this.cache[key] = item;
    }

    // #endregion

    // #region Get

    get(id: number, size: imageSize) {
        if (id == null) throw new Error('No key provided to image blob cache.');
        if (!size) throw new Error('No image size provided to image blob cache.');

        const item = this.cache[`ibcache-${id}-${size}`];

        return item;
    }

    // #endregion

    // #region Remove

    remove(id: number, size?: imageSize) {
        if (id == null) throw new Error('No key provided to image blob cache.');

        ['thumb', 'full'].forEach((sz) => {
            if (!size || size === sz) {
                const key = `ibcache-${id}-${sz}`;
                let item = this.cache[key];

                item?.dispose();
                item = null;

                delete this.cache[key];
            }
        });
    }

    // #endregion

    // #region Set

    set(id: number, size: imageSize, item: ImageBlob) {
        this.add(id, size, item);
    }

    // #endregion
}
